import { Avatar, Flex, Input, List, Menu, Space } from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ReactComponent as UserIcon } from "../../../assets/icon/userIcon.svg";
import styles from "../styles/MyTimesheet.module.css";

const TeamEmployeeList = ({
    isLoading = false,
    setEmployeeTeam = () => { },
    setEmployeeName = () => { },
    employeeMenu = () => { },
    pagination = {},
    total = 0,
    setPagination = () => { },
    onSelectEmployee = () => { },
    getAllEmployee = () => { },
}) => {
    const { t, i18n } = useTranslation();
    const [selectedKey, setSelectedKey] = useState(null);
    const [search, setSearch] = useState(null)
    const { Search } = Input;

    useEffect(() => {
        const employees = employeeMenu;
        if (employees && employees.length > 0 && !selectedKey) {
            const firstEmployee = employees[0];
            setSelectedKey(firstEmployee.key);
            setEmployeeTeam(firstEmployee.key);
            setEmployeeName(
                i18n.language === "en"
                    ? `${firstEmployee.tab.nameEn} ${firstEmployee.tab.surNameEn}`
                    : `${firstEmployee.tab.name} ${firstEmployee.tab.surName}`
            );
        }
    }, [employeeMenu, selectedKey, setEmployeeTeam, setEmployeeName, i18n.language]);

    const handleMenuClick = (item) => {
        setSelectedKey(item.key);
        onSelectEmployee(item.key);
    };

    function Employee(item = {}) {
        console.log("items ", item?.item?.tab);
        return (
            <Space direction="horizontal">
                <Flex gap={20} wrap>
                    <div>
                        <Avatar size={25} src={
                            item?.item?.tab?.image
                                ? "data:image/png;base64, " + item?.item?.tab?.image
                                : <UserIcon />} />
                    </div>

                    <Flex justify="flex-start">
                        <div>
                            <p>{i18n.language === 'en' ? item?.item?.tab?.nameEn + " " + item?.item?.tab?.surNameEn : item?.item?.tab?.name + " " + item?.item?.tab?.surName}</p>
                            <small>desc</small>
                        </div>
                    </Flex>
                </Flex>
            </Space>

        );
    }

    return (
        <Menu
            style={{
                padding: 10,
                height: "100%",
                minWidth: "12vw",
                borderRadius: '0.5rem',
                border: "1px solid #E8E8E8"
            }}
            selectedKeys={[selectedKey]}
        >
            <Search
                allowClear
                enterButton={t("common.search")}
                style={{ paddingBottom: "8px" }}
                className={styles.searchButton}
                onSearch={(value) => {
                    setSearch(value);
                    getAllEmployee(value);
                }}
            />

            <List
                loading={isLoading}
                dataSource={employeeMenu}
                renderItem={(item) => (
                    <Menu.Item key={item?.key}
                        onClick={() => handleMenuClick(item)}
                        style={{ backgroundColor: selectedKey === item?.key ? 'var(--sidebar-menu-color)' : 'transparent' }}
                    >
                        <Employee item={item}></Employee>
                    </Menu.Item>
                )}
                pagination={{
                    current: pagination.page + 1,
                    pageSize: pagination.pageSize,
                    total: total,
                    onChange: (page, pageSize) => {
                        setPagination((prev) => ({ ...prev, page: page - 1, pageSize }));
                    },
                }}
            >
            </List>
        </Menu>
    )
}

export default TeamEmployeeList;